import { USER_LOADED, AUTH_ERROR, LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT } from './types';
import URL from './url';

import setAuthToken from '../utils/setAuthToken';

//Load user
export const loadUser = () => async dispatch => {
  if(localStorage.token){
    setAuthToken(localStorage.token);
  }
  
  try {
    const res = await URL.get(`/api/auth`);
    
    dispatch({
      type: USER_LOADED,
      payload: res.data
    });
  } catch (err) {
    dispatch({
      type: AUTH_ERROR
    });
  }
}

//Login user
export const login = (email, password) => async dispatch => {
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };
  const body = JSON.stringify({ email, password });
  
  try {
    const res = await URL.post(`/api/auth`, body, config);
    dispatch({
      type: LOGIN_SUCCESS,
      payload: res.data
    });

    await dispatch(loadUser())
  } catch (err) {
    const errors = err.response.data.errors;
    
    dispatch({
      type: LOGIN_FAIL,
      payload: errors
    });
  }
}

//Logout
export const logout = () => dispatch => {
  dispatch({
    type: LOGOUT
  });
}